import en from "./locales/en";
import de from "./locales/de";
import es from "./locales/es";
import fr from "./locales/fr";

export default {
  en,
  de,
  es,
  fr
};
